module.exports = __webpack_public_path__ + "img/ready.116836fd.jpg";